import {
  buildServices
} from './utils/build_services'
import { UAA } from '@/services/axios.config'

const services = [
  {
    name: 'userLogin',
    method: 'post',
    url: () => `/authenticate`,
    data: (params) => {
      return {
        username: params.username,
        password: params.password
      }
    }
  },
  {
    name: 'userStatus',
    method: 'get',
    url: () => `/auth/status`
  },
  {
    name: 'userForgotPassword',
    method: 'post',
    url: (params) => `/users/reset-password?email=${params.email}`
  },
  {
    name: 'userStateStatus',
    method: 'get',
    url: () => `/auth/state/status`
  },
]

export const {
  userLogin,
  userStatus,
  userForgotPassword,
  userStateStatus,
} = buildServices(UAA, services)
